<template>
	<div>
		<template v-if="!disabled && !readonly && !renderCell">
<!-- 			<el-cascader collapse-tags :value="value" :size="size" :options="options" :placeholder="placeholder"
				:disabled="disabled" @change="change" :show-all-levels="false"
				:props="{checkStrictly: checkStrictly, multiple:multiple}" clearable filterable>
				<template slot-scope="{ node, data }">
					<span>{{ data.label }}</span>
					<span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
				</template>
			</el-cascader>
			<div class="full" @click="modal"></div> -->
			<el-select :value="value" :clearable="clearable" :size="size" :multiple="islist || multiple"
				:placeholder="placeholder" :disabled="disabled" @change="change" :collapse-tags="collapseTags" filterable>
				<el-option v-for="item in sourceData" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<div  class="full" @click="modal" v-if="!disabled && !readonly && ismodal" style="z-index: 999;"></div>
			
		</template>
		<template v-else>
			<span v-if="renderCell">{{valuetext}}</span>
			<el-input v-else v-model="valuetext" :disabled="disabled" :readonly="readonly" :size="size"></el-input>
		</template>

		<vxe-modal v-model="modalShow" :width="800" :height="800" show-footer destroy-on-close @show="show" @hide="hide"
			transfer :lock-scroll="false">
			<template #title>
				<div>选择部门</div>
			</template>
			<template #default>
				<el-tabs v-model="activeName" @tab-click="handleClick" type="card">
					<el-tab-pane label="部门" name="modalDepartment">
						<modalDepartment :departmentid="departmentid" :multiple="islist || multiple"
							ref="modalDepartment" />
					</el-tab-pane>
				</el-tabs>
				<transition name="el-fade-in-linear">
					<div class="full flex form_loading" v-if="loading"
						style="background-color: rgba(255, 255, 255, .5);z-index: 999;color: #409EFF;">
						<i class="vxe-icon-refresh roll"></i>
						<span>正在加载</span>
					</div>
				</transition>
			</template>
			<template #footer>
				<vxe-button status="" content="取消" @click="modalShow=false"></vxe-button>
				<vxe-button status="primary" content="确定" @click="submit"></vxe-button>
			</template>
		</vxe-modal>

	</div>
</template>

<style scoped>
	.readonly {
		pointer-events: none;
	}

	.readonly>* {
		pointer-events: none;
	}

	.form_loading {
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
</style>
<script>
	import selectBase from '@_system/components/base/select.js'
	import modalDepartment from './modal/department.vue'
	export default {
		mixins: [selectBase],
		props: {
			multiple: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			checkStrictly: {
				type: Boolean,
				default: () => {
					return true
				}
			},
			ismodal: {
				type: Boolean,
				default: () => {
					return true
				}
			}
		},
		data() {
			return {
				departmentid: [],
				ready: false,
				options: [],
				sourceData: [],
				activeName: 'modalDepartment',
				store: {},
				fApi: {},
				modalShow: false,
				loading: false,
				valuetext: ''
			}
		},
		created() {
			this.init()
			this.getValuetext(this.value)
		},
		watch: {
			value(value) {
				this.getValuetext(value)
			}
		},
		computed: {

		},

		methods: {
			setSelf() {
				let field = this.formCreateInject.field
				let value = this.formCreateInject.api.myformOption.$store.state.system.user.departmentid
				this.formCreateInject.api.setValue(field, value)
			},
			getValuetext(value) {
				let valuetext = []
				let tempvalue = []
				if(Array.isArray(value)){
					tempvalue = value
				}else{
					tempvalue = [value]
				}
				
				this.sourceData.forEach((item) => {
					tempvalue.forEach((_item)=>{
						if (item.id == _item) {
							valuetext.push(item.name)
						}
					})

				})
				this.valuetext = valuetext.join(',')
			},
			list() {
				if (!window.systemData.department) {
					this.$api.department.list({
						currentPage: -1
					}).then((res) => {

						// let options = []
						res.list.forEach((item) => {
							item.value = item.id
							item.label = item.name
						})
						this.sourceData = res.list
						this.options = this.createTree(res.list)

						this.finish()
					})
				} else {
					let list = JSON.parse(JSON.stringify(window.systemData.department))
					this.sourceData = list
					list.forEach((item) => {
						item.value = item.id
						item.label = item.name
					})
					this.options = this.createTree(list)
					this.finish()

				}
			},
			init() {


			},
			show() {

			},
			hide() {
				this.loading = false
				this.back()
			},
			handleClick() {

			},
			getparent(item, bread) {
				if (item.parentid == 0) {
					return item
				} else {
					for (let i = 0; i < this.sourceData.length; i++) {
						if (item.parentid == this.sourceData[i].id) {
							bread.unshift(this.sourceData[i].id)
							this.getparent(this.sourceData[i], bread)
						}
					}
				}
			},
			submit() {
				let value = null
				let data = this.$refs.modalDepartment.submitData()

				if (data.length != 0) {
					if (this.islist || this.multiple) {
						value = data.map((item) => {
							return item.departmentid
						})
					} else {
						value = data[0].departmentid
					}
				}
				
				if (this.formCreateInject) {
					let field = this.formCreateInject.field
					this.formCreateInject.api.setValue(field, value)
				}else if (this.tableFormInfo) {
					this.tableFormInfo.$form.data[this.tableFormInfo.field] = value
				}else if (this.row && this.column) {
					this.row[this.column.field] = value
				}
				this.$emit('modalsubmit', {
					data: value
				})
				this.change(value)
				this.back()
				
				// let data = this.$refs.modalDepartment.submitData()
				// let field = null
				// if (this.formCreateInject) {
				// 	field = this.formCreateInject.field
				// } else if (this.tableFormInfo) {
				// 	field = this.tableFormInfo.field
				// } else if (this.row && this.column) {
				// 	field = this.column.field
				// }
				// let value = []
				// let breadValue = []
				// if (this.multiple) {
				// 	data.forEach((item) => {
				// 		value.push(item.departmentid)
				// 	})
				// 	value.forEach((item) => {
				// 		let bread = []
				// 		let _item = this.getSourceItemByid(item)
				// 		this.getparent(_item, bread)
				// 		bread.push(item)
				// 		breadValue.push(bread)
				// 	})
				// 	this.formCreateInject.api.setValue(field, breadValue)
				// } else {
				// 	value = data.length != 0 ? data[0].departmentid : null

				// 	if (this.formCreateInject) {
				// 		this.formCreateInject.api.setValue(field, value)
				// 	} else {
				// 		if (this.tableFormInfo) {
				// 			this.tableFormInfo.$form.data[field] = value
				// 		}
				// 		if (this.row && this.column) {
				// 			this.row[field] = value
				// 		}
				// 	}

				// }
				// this.back()
			},
			getSourceItemByid(id) {
				for (let i = 0; i < this.sourceData.length; i++) {
					if (this.sourceData[i].id == id) {
						return this.sourceData[i]
					}
				}
			},
			modal() {
				let arr = []
				arr.push(this.value)
				this.departmentid = arr
				this.modalShow = true
			},
			back() {
				this.modalShow = false
			},
		},
		components: {
			modalDepartment
		}
	}
</script>
